import React from 'react';
import { IfHasPermissionProps } from './IfHasPermission.type';

const PERMISSION_DENIED_MESSAGE = "You don't have permission to perform this action";

export const IfHasPermission: React.FC<IfHasPermissionProps> = ({
  permissions = [],
  requires,
  mode = 'any',
  children,
  fallback = null,
  showDisabled = false,
}) => {
  const requiredPermissions = Array.isArray(requires) ? requires : [requires];
  
  const hasPermission = mode === 'all'
    ? requiredPermissions.every(perm => permissions.includes(perm))
    : requiredPermissions.some(perm => permissions.includes(perm));

  if (!hasPermission && showDisabled) {
    return (
      <>
        {React.Children.map(children, child => {
          if (React.isValidElement(child)) {
            return React.cloneElement(child, {
              disabled: true,
              title: PERMISSION_DENIED_MESSAGE,
              ...child.props,
            } as any);
          }
          return child;
        })}
      </>
    );
  }

  if (!hasPermission) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
};